import { useProfile } from "../../components/portfolio/context/ProfileContext"

function Education() {
   const { eduDetails } = useProfile()

   return (
      <>
         <section id="education-section">
            <div className="edu-title">
               <h1>Education & Diplomas</h1>
               <h5>What I have done in my academic career</h5>
            </div>
            <ul className="education-list">
               {eduDetails.map((details) => {
                  return <li className="edu-info" key={details.id || `${details.title}-${details.year}`}>
                     <div className="edu-year">
                        <img
                           src={details.src}
                           loading="lazy"
                           alt={details.title} />
                     </div>
                     <div className="edu-description">
                        <h1>{details.title}</h1>
                        <h5>{details.subtitle}</h5>
                        <h5>{details.year}</h5>
                     </div>
                  </li>
               })}
            </ul>
         </section>
      </>
   );
}
export default Education;
